// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"500":"3361cec6","952":"a35df55a"}[chunkId] + ".chunk.js";
};